var _ellipse, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgToyotaYellowAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 11,
    ry: 10.7454,
    transform: "matrix(-1 0 0 1 11 11.2825)",
    fill: "#FEB948"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7545 16.0581C10.7633 16.0581 10.7721 16.0588 10.7809 16.0588C11.5905 16.0717 12.2366 16.725 12.2219 17.5152C12.208 18.2989 11.5546 18.9228 10.7553 18.9228H10.7296C9.92072 18.9085 9.27466 18.2566 9.28859 17.4665C9.30326 16.6828 9.95592 16.0581 10.7545 16.0581Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 4.1189C10.3731 4.1189 9.85655 4.51776 9.78595 5.03161L9.77772 5.15211V13.8311C9.77772 14.4017 10.3249 14.8643 10.9999 14.8643C11.6267 14.8643 12.1433 14.4654 12.2139 13.9516L12.2222 13.8311V5.15211C12.2222 4.58148 11.675 4.1189 10.9999 4.1189Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToyotaYellowAlert);
export default __webpack_public_path__ + "static/media/toyota-yellow-alert.869f8fd4.svg";
export { ForwardRef as ReactComponent };